export default __webpack_public_path__ + "static/gotham-light-7d6b97c7aca283e746730ec192b5989f.woff2";